<template>
  <div class="hero-container">
    <div v-if="brand.name === 'mini'" class="row">
      <ActionBar :heading="heading" :sub-heading="subHeading" :class="brand.name">
        <ScheduleServiceButton coupon-id="" v-bind:source="'hero-' + category" flavor="hero" v-bind:cta="cta"
        v-on:ctaAction="$emit('ctaAction')">
        </ScheduleServiceButton>
      </ActionBar>
    </div>
    <div class="row" v-on:click="scheduleService()">
      <ResponsiveImage class="psuedo-background-img-container" :class="brand.name"
        :hero-image="heroImage" :responsive-handle="responsive" :brand="brand" :dealer="dealer" :category="category">
        <template v-if="brand.name !== 'mini' &&  brand.name !== 'gmc'">
          <HeroOverlay :heading="heading" :sub-heading="subHeading">
            <ScheduleServiceButton coupon-id="" v-bind:source="'hero-' + category" flavor="hero" v-bind:cta="cta"
            v-on:ctaAction="$emit('ctaAction')">
            </ScheduleServiceButton>
          </HeroOverlay>
        </template>
      </ResponsiveImage>
    </div>
    <div v-if="brand.name === 'gmc'" class="row">
      <ActionBar :heading="heading" :sub-heading="subHeading" :class="brand.name">
        <ScheduleServiceButton coupon-id="" v-bind:source="'hero-' + category" flavor="hero" v-bind:cta="cta"
        v-on:ctaAction="$emit('ctaAction')">
        </ScheduleServiceButton>
      </ActionBar>
    </div>
  </div>
</template>

<script>
import ActionBar from '@/components/ActionBar'
import ScheduleServiceButton from '@/components/ScheduleServiceButton'
import ResponsiveImage from '@/components/ResponsiveImage'
import HeroOverlay from '@/components/HeroOverlay'
import { mapGetters } from 'vuex'

export default {
  name: 'HeroBanner',
  components: {
    ScheduleServiceButton,
    ActionBar,
    ResponsiveImage,
    HeroOverlay
  },
  props: {
    brand: {
      type: Object
    },
    dealer: {
      type: Object
    },
    responsive: String,
    heroImage: String,
    heading: {
      type: String,
      default: 'Appointments in One Click'
    },
    subHeading: {
      type: String,
      default: 'Easily Schedule BMW Service Today'
    },
    category: {
      type: String,
      default: 'hero'
    },
    cta: {
      type: String,
      default: 'schedule'
    }
  },
  computed: {
    ...mapGetters({
      scheduleEnabled: 'scheduleEnabled'
    })
  },
  methods: {
    scheduleService: function () {
      // if we are on a mobile device then clicking the hero image opens up the schedule dialog
      if (window.innerWidth < 576 && this.cta === 'schedule') {
        this.$nextTick(() => { this.$router.replace({ name: 'appointment' }).catch(() => {}) })
      }
    }
  }
}
</script>

<style scoped>
/* styles for xs screens go here */
.psuedo-background-img-container {
  /*height: 45vh; */
  box-sizing: border-box;
  height: 400px;
  max-height: 600px;
  width: 100%;
  position: relative;
}
.psuedo-background-img-container:not(.mini)::after {
  content:'';
  position:absolute;
  left:0;
  top:0;
  width:100%;
  height:100%;
  display:inline-block;
  background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))
}
.psuedo-background-img-container:not(.gmc)::after  {
  content:'';
  position:relative;
  left:0;
  top:0;
  width:100%;
  height:100%;
  display:inline-block
}
/* styles for different screen widths follow */
@media only screen and (min-width: 576px) {
}
@media only screen and (min-width: 768px) {
  .psuedo-background-img-container {
    height: 500px;
  }
}
@media only screen and (min-width: 992px) {
}
@media only screen and (min-width: 1200px) {
  .psuedo-background-img-container {
    height: 600px;
  }
}
</style>
